import React, { useEffect } from "react";
import Banner from "../Components/Home/Banner/Banner";
import CollectionBox from "../Components/Home/Collection/CollectionBox";
import Services from "../Components/Home/Services/Services";
import Instagram from "../Components/Home/Instagram/Instagram";
import LimitedEdition from "../Components/Home/Limited/LimitedEdition";
import HeroSection from "../Components/Home/Hero/HeroSection";
import Medecines from "../Components/Home/Medicine/Medecines";
import PopularCategory from "../Components/PopularCategeory/PopularCategeory";
import Banner1 from "../Components/Home/Banner1/Banner1";
import ProductFilter from "../Components/ProductFilter/ProductFilter";
import SliderComponent from "../Components/SliderComponent/SliderComponent";
import BrandSlider from "../Components/BrandSlider/BrandSlider";
import CategoryCards from "../Components/CategoryCards/CategoryCards";
import BlogList from "../Components/Blog/BlogList/BlogList";
import FindNearestUser from "../Components/FindNearestUser/FindNearestUser";
import CallMePage from "../Components/CallForAppointment/CallMePage";
import Testimonials from "../Components/Home/Testimonials/Testimonials";
import HomeBlogs from "../Components/Home/Blogs/HomeBlogs";
import HomeBanner from "../Components/Home/HomeBanner/HomeBanner";
import QRPopup from "../Components/QRPopup/QRPopup";
import CallButton from "../Components/CallButton/CallButton";

const Home = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <HeroSection />
      {/* <ProductFilter/> */}
      <BrandSlider />
      <CollectionBox />
      <CategoryCards />
      <PopularCategory />
      {/* <SliderComponent/> */}
      {/* <Banner1/> */}
      {/* <Banner /> */}
        <LimitedEdition />
      <HomeBanner />
      <FindNearestUser />
      <HomeBlogs />
      <Instagram />
      <Testimonials />
      <Services />
      <CallButton/>
      <QRPopup/>
    </>
  );
};

export default Home;
